<app-main-nav *ngIf="isAuthenticated">
  <router-outlet></router-outlet>
</app-main-nav>
